import React, {Component} from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames';
import {connect} from 'react-redux';
import IconSearch from '@spothero/icons/search';
import AutoSuggestInput from '@spothero/ui/auto-suggest-input';
import {getAirports} from 'search/search-actions';

const STRIP_NON_ALPHANUMERIC = string => {
    const nonAlphaNumeric = /[^\w\d\s:]/gi;

    return string.replace(nonAlphaNumeric, '').toLowerCase();
};

export class SelectAirport extends Component {
    componentDidMount() {
        const {isLoaded, onGetAirports} = this.props;

        if (!isLoaded) {
            onGetAirports();
        }
    }

    render() {
        const {
            className,
            options,
            onClear,
            onSelect,
            searchText,
            showSuggestions,
            ...props
        } = this.props;
        const classes = classnames('SelectAirport', className);

        return (
            <AutoSuggestInput
                {...props}
                type="search"
                autoActivateFirstSuggest={Boolean(options.length)}
                className={classes}
                defaultValue={searchText}
                icon={<IconSearch />}
                onClear={onClear}
                onSuggestionSelect={options.length ? onSelect : onClear}
                suggestions={
                    showSuggestions
                        ? searchText && !options.length
                            ? SelectAirport.defaultProps.options
                            : options
                        : []
                }
            />
        );
    }
}

SelectAirport.propTypes = {
    isLoaded: PropTypes.bool,
    showSuggestions: PropTypes.bool,
    onClear: PropTypes.func,
    onSelect: PropTypes.func,
    onGetAirports: PropTypes.func,
    className: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
            id: PropTypes.string,
        })
    ),
    searchText: PropTypes.string,
};

SelectAirport.defaultProps = {
    options: [
        {
            label: 'No Airports Found',
            value: '',
            id: 'null',
        },
    ],
    searchText: '',
};

const mapStateToProps = ({search}, {searchText}) => {
    const options = get(search, 'data.airports', null);

    return {
        isLoaded: Boolean(options),
        options: (options || [])
            .filter(({name, iata_code: iataCode, city}) =>
                STRIP_NON_ALPHANUMERIC(
                    [name, iataCode, city].join(' ')
                ).includes(STRIP_NON_ALPHANUMERIC(searchText))
            )
            .map(({name: label, iata_code: value}, index) => ({
                label: `${label} (${value})`,
                value,
                id: value || index,
            })),
    };
};

const mapDispatchToProps = {
    onGetAirports: getAirports,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectAirport);
